exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ninput[type=\"checkbox\"]:disabled {\n    color: red;\n    background-color: lightgrey;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/AgentSetting/CreateBrand2.vue"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,4BAA4B;CAC/B","file":"CreateBrand2.vue","sourcesContent":["\ninput[type=\"checkbox\"]:disabled {\n    color: red;\n    background-color: lightgrey;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c2c3978","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/AgentSetting/CreateBrand2.vue
// module id = BOfN
// module chunks = 2